export default __webpack_public_path__ + "static/media/visitorICon.3870e07d.svg";